import { useLayoutEffect, useRef, useState } from "react";

/** Grow the text in place; controls keep one bottom baseline.
 * Текст росте вгору в одній області; кнопки зберігають нижню базову лінію. */
export function useComposerLayout(draft: string, hasChips: boolean) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [expanded, setExpanded] = useState(hasChips);
  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    const resize = () => {
      const style = getComputedStyle(textarea);
      const line = parseFloat(style.lineHeight) || 24;
      const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
      const viewport = window.visualViewport?.height ?? window.innerHeight;
      const lines = Math.max(2, Math.floor((Math.min(320, viewport * 0.4) - padding) / line));
      textarea.style.maxHeight = `${lines * line + padding}px`;
      textarea.style.height = "0px";
      const height = textarea.scrollHeight;
      textarea.style.height = `${height}px`;
      setExpanded(hasChips || (draft.length > 0 && height > 36));
    };
    resize();
    let width = textarea.getBoundingClientRect().width;
    let frame = 0;
    const observer = new ResizeObserver(() => {
      const nextWidth = textarea.getBoundingClientRect().width;
      if (nextWidth === width) return;
      width = nextWidth;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(resize);
    });
    observer.observe(textarea);
    window.visualViewport?.addEventListener("resize", resize);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.visualViewport?.removeEventListener("resize", resize);
    };
  }, [draft, hasChips]);
  return { textareaRef, expanded };
}
